/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateEventIndex } from '../../axios/candidateEventIndex'
import type {
	CandidateEventIndexError,
	CandidateEventIndexPathParams,
	CandidateEventIndexResponse,
} from '../../types/CandidateEventIndex'

export const candidateEventIndexQueryKey = (candidate: CandidateEventIndexPathParams['candidate']) =>
	[{ url: '/candidates/:candidate/events', params: { candidate } }] as const

export type CandidateEventIndexQueryKey = ReturnType<typeof candidateEventIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEventController.php CandidateEventController::index */
export function candidateEventIndexQueryOptions(
	candidate: CandidateEventIndexPathParams['candidate'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidateEventIndexResponse,
		AxiosError<CandidateEventIndexError>,
		CandidateEventIndexResponse,
		CandidateEventIndexQueryKey
	>({
		queryKey: candidateEventIndexQueryKey(candidate),
		queryFn: ({ signal }) => candidateEventIndex(candidate, { signal, ...config }).then(res => res.data),
		enabled: !!candidate,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEventController.php CandidateEventController::index */
export function useCandidateEventIndex<TSelectData = CandidateEventIndexResponse>(
	candidate: CandidateEventIndexPathParams['candidate'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidateEventIndexResponse,
					AxiosError<CandidateEventIndexError>,
					TSelectData,
					CandidateEventIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidateEventIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidateEventIndexQueryOptions(candidate),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEventController.php CandidateEventController::index */
export function useCandidateEventIndexSuspense<TSelectData = CandidateEventIndexResponse>(
	candidate: CandidateEventIndexPathParams['candidate'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidateEventIndexResponse,
					AxiosError<CandidateEventIndexError>,
					TSelectData,
					CandidateEventIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidateEventIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidateEventIndexQueryOptions(candidate),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
